import React from "react";
import { useNavigate } from "react-router-dom";
import RenewalLayout from "../../components/RenewalLayout";

const shimmer =
  "relative overflow-hidden bg-[#E5E9EB] before:absolute before:inset-0 before:-translate-x-full before:animate-[policyShimmer_1.4s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/70 before:to-transparent";

const Bar = ({ className = "" }) => (
  <span className={`block rounded-md ${shimmer} ${className}`} />
);

const TableRowSkeleton = ({ isLast = false }) => (
  <tr>
    <td className={`py-2 px-4 border-r rtl:border-l h-[44px] w-1/3 ${isLast ? "" : "border-b"}`}>
      <Bar className="h-4 w-28" />
    </td>
    <td className={`py-2 px-4 ${isLast ? "" : "border-b"}`}>
      <Bar className="h-4 w-36" />
    </td>
  </tr>
);

const DomesticHelperRenewalSkeleton = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`@keyframes policyShimmer { 100% { transform: translateX(100%); } }`}</style>
      <div className="mainCarDetailsModal pt-[1%] pb-[5%] max767:w-full max767:overflow-y-scroll max767:pb-[30%] max767:h-screen ipad:pt-[10%] ipad:h-[93vh] ipad:overflow-y-scroll">
        <RenewalLayout
          policyType="domesticHelper"
          show_close_btn={false}
          is_hide_back_btn={false}
          backClickHandler={() => navigate("/renew")}
          hideContinueBtn
          is_bottom_sticky_layout={false}
        >
          <div className="flex flex-col items-center mx-auto max-w-lg max767:px-[22px] pt-0 w-full">
            <div className="flex justify-center items-center w-full">
              <div className="p-0 w-full">
                {/* Title and description */}
                <div className="max767:mt-2 mb-4">
                  <Bar className="h-7 w-52 mb-3" />
                  <Bar className="h-4 w-4/5 mt-2" />
                </div>

                {/* Policy Details Card */}
                <div className="mt-6">
                  <div className="bg-[#F6F8F9] mb-6 p-4 max767:bg-white max767:p-0 rounded-2xl">
                    <Bar className="h-5 w-64 mb-3" />
                    <Bar className="h-4 w-52 mb-4 mt-2" />
                    {/* Table with mobile horizontal scroll */}
                    <div className="max767:overflow-x-scroll">
                      <table className="min-w-full border-separate bg-white border border-solid border-[#DDE2E4] border-spacing-0 rounded-[10px]">
                        <tbody>
                          <TableRowSkeleton />
                          <TableRowSkeleton />
                          <TableRowSkeleton />
                          <TableRowSkeleton />
                          <TableRowSkeleton isLast />
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Summary Section */}
            <div className="bg-[#F6F8F9] rounded-[26px] p-4 max767:bg-white max767:p-0 mb-6 w-full">
              <div className="flex items-center gap-2 mb-4 pb-4 border-b border-[#DDE2E4]">
                <Bar className="h-10 flex-1 rounded-lg" />
                <Bar className="h-10 w-20 rounded-lg" />
              </div>
              <div className="flex justify-between py-2.5">
                <Bar className="h-4 w-32" />
                <Bar className="h-4 w-20" />
              </div>
              <div className="flex justify-between py-2.5 border-t border-[#DDE2E4]">
                <Bar className="h-4 w-24" />
                <Bar className="h-4 w-20" />
              </div>
              <div className="flex justify-between py-2.5 border-t border-[#DDE2E4]">
                <Bar className="h-5 w-16" />
                <Bar className="h-5 w-24" />
              </div>
            </div>

            {/* Notice box */}
            <div className="mb-6 p-4 bg-[#FDE9D2] border border-[#FBC98E] rounded-lg w-full">
              <Bar className="h-4 w-4/5" />
            </div>

            {/* Terms checkbox */}
            <div className="mb-6 w-full flex items-start gap-3 max767:pb-24">
              <Bar className="h-5 w-5 flex-shrink-0" />
              <div className="flex-1 space-y-1.5">
                <Bar className="h-4 w-full" />
                <Bar className="h-4 w-4/5 mt-1.5" />
              </div>
            </div>

            {/* Proceed button — mirrors actual page mobile-fixed / desktop-inline pattern */}
            <div className="max767:bg-white max767:border-t max767:border-[#E5E9EB] max767:mt-2 max767:py-4 flex max767:flex-col mt-4 max767:fixed max767:bottom-0 max767:p-4 max767:inset-x-0 ipad:items-center max767:inline-block max767:z-[9] w-full">
              <Bar className="h-10 w-full rounded-[10px] max767:h-[40px]" />
            </div>
          </div>
        </RenewalLayout>
      </div>
    </>
  );
};

export default DomesticHelperRenewalSkeleton;
